import { createApp } from "vue";
import { Dialog, Loading, Notify, Quasar } from "quasar";
import langDe from "quasar/lang/de";

// Import icon libraries
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";

// Import Quasar css
import "quasar/src/css/index.sass";

// Import app styles
import "@/css/app.scss";

import App from "./App.vue";
import router from "./router";
import pinia from "./stores";
import QuantumSpinner from "@/components/QuantumSpinner.vue";

const app = createApp(App);

app.use(Quasar, {
  plugins: {
    Dialog,
    Loading,
    Notify,
  },
  lang: langDe,
  config: {
    loading: {
      message: 'Speichere Antworten ...',
      messageColor: 'white',
      backgroundColor: 'grey-10',
      spinnerColor: 'white',
      spinnerSize: 60,
      delay:3,
      spinner: QuantumSpinner,
      customClass: 'loading-overlay-custom',
    },
  }
});

app.use(pinia);
app.use(router);

app.mount("#app");
